import React from 'react';
import { useIntl } from 'react-intl/dist';

import { DATE_FORMATS } from '../../../../constants/common/dateTimeValues';
import { ConditionalRendering } from '../../../../components/common/conditional-rendering';
import { formatDateString } from '../../../../utils/dates/dateMethods';
import { IEnrolleeDataDto } from '../common/types';
import { StyledRow, StyledColumn, StyledBoldUnderline } from './ModalStyles';

interface IHouseholdInfoTableProps {
    enrollees: IEnrolleeDataDto[];
}

const HouseholdInfoTable = ({ enrollees = [] }: IHouseholdInfoTableProps) => {
    const intl = useIntl();
    const noData = intl.formatMessage({ id: 'member.enrollment.modal.cancelTerminate.NA' });

    return (
        <>
            <StyledRow>
                <StyledColumn>
                    <StyledBoldUnderline data-testid="about-household">
                        {intl.formatMessage({ id: 'member.enrollment.modal.cancelTerminate.aboutHousehold' })}
                    </StyledBoldUnderline>
                </StyledColumn>
            </StyledRow>
            <StyledRow>
                <StyledColumn>
                    <StyledBoldUnderline data-testid="name">
                        {intl.formatMessage({ id: 'member.enrollment.modal.cancelTerminate.name' })}
                    </StyledBoldUnderline>
                </StyledColumn>
                <StyledColumn>
                    <StyledBoldUnderline data-testid="memberId">
                        {intl.formatMessage({ id: 'member.enrollment.modal.cancelTerminate.memberId' })}
                    </StyledBoldUnderline>
                </StyledColumn>
                <StyledColumn>
                    <StyledBoldUnderline data-testid="coverageDates">
                        {intl.formatMessage({ id: 'member.enrollment.modal.cancelTerminate.coverageDates' })}
                    </StyledBoldUnderline>
                </StyledColumn>
                <StyledColumn>
                    <StyledBoldUnderline data-testid="memberEventType">
                        {intl.formatMessage({ id: 'member.enrollment.modal.cancelTerminate.memberEventType' })}
                    </StyledBoldUnderline>
                </StyledColumn>
                <StyledColumn>
                    <StyledBoldUnderline data-testid="memberMaintenanceReason">
                        {intl.formatMessage({ id: 'member.enrollment.modal.cancelTerminate.memberMaintenanceReason' })}
                    </StyledBoldUnderline>
                </StyledColumn>
            </StyledRow>
            {enrollees?.map((enrollee, index) => (
                <StyledRow key={index}>
                    <StyledColumn data-testid={`enrollee-name-${index}`}>
                        <ConditionalRendering isTrue={enrollee.SubscriberFlag === 'YES'}>
                            {enrollee.firstName} {enrollee.lastName} *
                        </ConditionalRendering>
                        <ConditionalRendering isTrue={!enrollee.SubscriberFlag}>
                            {enrollee.firstName} {enrollee.lastName}
                        </ConditionalRendering>
                    </StyledColumn>
                    <StyledColumn data-testid={`enrollee-memberId-${index}`}>{enrollee.memberId}</StyledColumn>
                    <StyledColumn data-testid={`enrollee-coverageDates-${index}`}>
                        {formatDateString(enrollee.effectiveStartDate, DATE_FORMATS.MM_DD_YYYY)} -{' '}
                        {formatDateString(enrollee.effectiveEndDate, DATE_FORMATS.MM_DD_YYYY)}
                    </StyledColumn>
                    <StyledColumn data-testid={`enrollee-eventType-${index}`}>
                        {enrollee.eventType ? enrollee.eventType : noData}
                    </StyledColumn>
                    <StyledColumn data-testid={`enrollee-eventReason-${index}`}>
                        {enrollee.eventReason ? enrollee.eventReason : noData}
                    </StyledColumn>
                </StyledRow>
            ))}
        </>
    );
};

export default HouseholdInfoTable;
